export const OVERVIEW_ENGLISH = {
  "datox.overview.title": "Overview",
  "datox.overview.eyebrow": "Your workspace, at a glance",
  "datox.overview.description": "The latest insights. Every portfolio. One place.",
  "datox.overview.refresh": "Refresh overview",
  "datox.overview.refreshing": "Refreshing…",
  "datox.overview.filters": "Filter your workspace",
  "datox.overview.projects": "Projects",
  "datox.overview.periods": "Period",
  "datox.overview.clients": "Clients",
  "datox.overview.allProjects": "All projects",
  "datox.overview.allPeriods": "All periods",
  "datox.overview.allClients": "All clients",
  "datox.overview.unassigned": "Unassigned client",
  "datox.overview.projectWide": "Project-wide",
  "datox.overview.unavailableFilter": "Selected value is unavailable",
  "datox.overview.clear": "Clear filters",
  "datox.overview.filtered": "Showing your selected scope",
  "datox.overview.allScope": "Across your accessible projects",
  "datox.overview.metric.report": "Reports",
  "datox.overview.metric.clients": "Clients represented",
  "datox.overview.metric.projects": "Projects with reports",
  "datox.overview.metric.periods": "Periods represented",
  "datox.overview.latestReports": "Latest reports",
  "datox.overview.reportLatestHint": "Latest completed revision of each report",
  "datox.overview.reportEmptyHint": "Try another project, period, or client to find your saved reports.",
  "datox.overview.latest": "Latest",
  "datox.overview.open.report": "Open report",
  "datox.overview.openNamed": "Open {{title}}",
  "datox.overview.revision": "Revision {{number}}",
  "datox.overview.saved": "Saved report",
  "datox.overview.asOf": "As of {{date}}",
  "datox.overview.updated": "Updated {{date}}",
  "datox.overview.empty.report": "No reports in this view",
  "datox.overview.factsheets": "Client factsheets",
  "datox.overview.factsheetsHint": "The latest report for each portfolio and period.",
  "datox.overview.portfolio": "Client / portfolio",
  "datox.overview.scope": "Project / period",
  "datox.overview.report": "Report",
  "datox.overview.lastUpdated": "Last updated",
  "datox.overview.emptyFactsheets": "Your client factsheets will appear here",
  "datox.overview.emptyFactsheetsHint": "Saved portfolio reports will appear here, organized by client and period.",
  "datox.overview.emptyFilteredFactsheets": "No factsheets match these filters",
  "datox.overview.emptyFilteredHint": "Choose another project, period, or client to see more portfolios.",
  "datox.overview.emptyPage": "No portfolios on this page",
  "datox.overview.emptyPageHint": "The available outputs may have changed. Return to the first page to see them.",
  "datox.overview.firstPage": "Back to first page",
  "datox.overview.range": "{{start}}–{{end}} of {{total}} portfolios",
  "datox.overview.previous": "Previous",
  "datox.overview.next": "Next",
  "datox.overview.pagination": "Factsheet pages",
  "datox.overview.error": "We couldn’t load your overview",
  "datox.overview.errorHint": "Your saved work is still there. Please try again.",
  "datox.overview.retry": "Try again",
  "datox.overview.loading": "Loading your workspace overview…",
  "datox.overview.footer": "Latest completed revisions · Reports stay in their projects",
} as const
